import { Input } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface NumberProps {}

const Number: FC<NumberProps> = () => {
    const name = 'number'

    return (
        <Form.Item name={name} label={'Номер'}>
            <Input />
        </Form.Item>
    )
}

export default Number
